<template>
  <div :key="componentKey">
    <b-button
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        variant="outline-primary"
        size="sm"
        class="mb-1"

        @click="addReminder()"
    >
      {{ capitalize($t('addReminder')) }}
    </b-button>

    <b-card>
      <div class="mb-2 position-relative w-100 text-danger d-flex justify-content-center">
        <div
            class="position-absolute border-bottom w-100"
            style="top: 10px; z-index: 0"
        ></div>

        <div
            class="d-flex bg-white px-2"
            style="z-index: 10"
        >
          <icon
              icon="calendar-day"
              class="mr-50"
          />
          <div>
            <b>{{ capitalize($t('late')) }} ({{ countLate }})</b>
          </div>
        </div>

      </div>

      <div style="max-height: 45vh; overflow-y: auto">
        <!--    Yesterday-->
        <timeline v-if="lateYesterday.length >0">
          <time-line-item
              v-for="reminder in lateYesterday"
              :title="capitalize($t('reminders'))"
              icon="calendar-day"
          >
            <template #time>
              <span class="text-danger"> {{ capitalize($t('yesterday')) }}</span>
            </template>

            <reminder-card
                :reminder="reminder"
                :is-selectable="true"

                @edit="editReminder(reminder)"
                @checkReminder="checkReminder(reminder);checkReminderLocal(reminder)"
                @delete="removeReminderAlert(reminder)"
            />

          </time-line-item>
        </timeline>

        <!--    Day before yesterday-->
        <timeline v-if="lateDayBeforeYesterday.length >0">
          <time-line-item
              v-for="reminder in lateDayBeforeYesterday"
              :title="capitalize($t('reminders'))"
              icon="calendar-day"
          >
            <template #time>
              <span class="text-danger"> {{ capitalize($t('dayBeforeYesterday')) }}</span>
            </template>

            <reminder-card
                :reminder="reminder"
                :is-selectable="true"

                @edit="editReminder(reminder)"
                @checkReminder="checkReminder(reminder);checkReminderLocal(reminder)"
                @delete="removeReminderAlert(reminder)"
            />

          </time-line-item>
        </timeline>

        <!--    Last week-->
        <timeline v-if="lateLastWeek.length >0">
          <time-line-item
              v-for="reminder in lateLastWeek"
              :title="capitalize($t('reminders'))"
              icon="calendar-day"
          >
            <template #time>
              <span class="text-danger"> {{ capitalize($t('lastWeek')) }}</span>
            </template>

            <reminder-card
                :reminder="reminder"
                :is-selectable="true"

                @edit="editReminder(reminder)"
                @checkReminder="checkReminder(reminder);checkReminderLocal(reminder)"
                @delete="removeReminderAlert(reminder)"
            />

          </time-line-item>
        </timeline>

        <!--    Last month-->
        <timeline v-if="lateLastMonth.length >0">
          <time-line-item
              v-for="reminder in lateLastMonth"
              :title="capitalize($t('reminders'))"
              icon="calendar-day"
          >
            <template #time>
              <span class="text-danger"> {{ capitalize($t('lastMonth')) }}</span>
            </template>

            <reminder-card
                :reminder="reminder"
                :is-selectable="true"

                @edit="editReminder(reminder)"
                @checkReminder="checkReminder(reminder);checkReminderLocal(reminder)"
                @delete="removeReminderAlert(reminder)"
            />

          </time-line-item>
        </timeline>

        <!--    For far too long-->
        <timeline v-if="lateForFarTooLong.length >0">
          <time-line-item
              v-for="reminder in lateForFarTooLong"
              :title="capitalize($t('reminders'))"
              icon="calendar-day"
          >
            <template #time>
              <span class="text-danger"> {{ capitalize($t('forFarTooLong')) }}</span>
            </template>

            <reminder-card
                :reminder="reminder"
                :is-selectable="true"

                @edit="editReminder(reminder)"
                @checkReminder="checkReminder(reminder);checkReminderLocal(reminder)"
                @delete="removeReminderAlert(reminder)"
            />

          </time-line-item>
        </timeline>
      </div>

      <!--    without completion date -->
      <div class="mt-1 ml-50 text-secondary">
        <div
            class="d-flex justify-content-between cursor-pointer"

            @click="isWithoutCompletionDateCollapsed=!isWithoutCompletionDateCollapsed"
        >
          <b>
            {{
              $tc('xWithoutCompletionDate', remindersWithoutCompletionDate, { number: remindersWithoutCompletionDate })
            }}
          </b>

          <div class="my-auto px-1">
            <icon
                v-if="isWithoutCompletionDateCollapsed"
                icon="caret-down"
            />
            <icon
                v-else
                icon="caret-left"
            />
          </div>
        </div>

        <div
            v-if="!isWithoutCompletionDateCollapsed"
            style="max-height: 45vh; overflow-y: auto"
        >
          <reminder-card
              v-for="reminder in reminders.withoutCompletionDate"
              :reminder="reminder"
              :is-selectable="true"
              class="my-1"

              @edit="editReminder(reminder)"
              @checkReminder="checkReminder(reminder);checkReminderLocal(reminder)"
              @delete="removeReminderAlert(reminder)"
          />
        </div>
      </div>
    </b-card>

    <b-card>
      <div class="mb-2 w-100 d-flex justify-content-center">

        <div
            class="bg-white"
            :class="{'cursor-pointer' : isPreviousDateAllowed}"

            @click="previousDate"
        >
          <icon
              icon="chevron-left"
              class="bg-white px-50"
              :disabled="!isPreviousDateAllowed"
          />
        </div>
        <div
            class="position-relative w-100 mx-1"
            style="z-index: 10"
        >
          <div
              class="position-absolute border-bottom w-100"
              style="top: 10px; z-index: 0"
          ></div>
          <div
              class="d-flex position-relative justify-content-center"
              style="z-index: 10"
          >
            <icon
                icon="calendar-day"
                class="pl-2 pr-50 bg-white"
            />
            <div class="bg-white pr-2">
              <span v-if="selectedDate == null">-</span>
              <span v-else>
                <b>{{ displaySelectedDate }}</b>
              </span>

            </div>
          </div>
        </div>
        <div
            class="bg-white "
            :class="{'cursor-pointer' : isNextDateAllowed}"

            @click="nextDate"
        >
          <icon
              icon="chevron-right"
              class="bg-white px-50"
              :disabled="!isNextDateAllowed"
          />
        </div>


      </div>

      <div style="max-height: 45vh; overflow-y: auto">
        <timeline v-if="'byDates' in reminders && selectedDate != null">
          <time-line-item
              v-for="reminder in reminders.byDates[selectedDate]"
              :title="capitalize($t('reminders'))"
              icon="calendar-day"
          >
            <reminder-card
                :reminder="reminder"
                :is-selectable="true"

                @edit="editReminder(reminder)"
                @checkReminder="checkReminder(reminder);checkReminderLocal(reminder)"
                @delete="removeReminderAlert(reminder)"
            />

          </time-line-item>
        </timeline>
      </div>
    </b-card>


    <!-- modal reminder-->
    <reminder-modal
        :reminder.sync="currentReminder"
        :title="reminderModalTitle"
        :isOpen.sync="reminderModalShow"

        @submitValidatedReminder="submitValidatedReminderLocal"
        @removeReminder="removeReminderAlert"
    />
  </div>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'
import Ripple                   from 'vue-ripple-directive'
import ReminderModal            from '../prompt/ReminderModal.vue'
import { clone }                from '../../utils/utils'
import store                    from '../../store'
import { useReminders }         from './useReminders'
import i18n                     from '../../libs/i18n'
import Timeline                 from '../timeline/Timeline.vue'
import TimeLineItem             from '../timeline/TimeLineItem.vue'
import { capitalize }           from '../../utils/filter'
import ReminderCard             from '../card/ReminderCard.vue'
import NextButton               from '../button/Next.vue'
import moment                   from 'moment'
import { mixinReminders }       from '../../mixins/mixinReminders'

export default {
  directives: {
    Ripple,
  },
  mixins: [mixinReminders],
  components: {
    ReminderCard,
    TimeLineItem,
    Timeline,
    ReminderModal,
    NextButton
  },
  props: {
    reminders: {
      type: Object,
      default: () => {}
    }
  },
  setup (props, { emit }) {
    // ------------------------------------------------
    // Data
    // ------------------------------------------------
    // const currentReminder = ref({})
    // const reminderModalShow = ref(false)
    // const reminderModalTitle = ref(i18n.t('NewReminder'))
    const selectedDate = ref(null)

    // ------------------------------------------------
    // Computed
    // ------------------------------------------------
    const lateYesterday = computed(() => {
      if ('late' in props.reminders) {
        return props.reminders.late.yesterday
      } else {
        return []
      }
    })
    const lateDayBeforeYesterday = computed(() => {
      if ('late' in props.reminders) {
        return props.reminders.late.dayBeforeYesterday
      } else {
        return []
      }
    })
    const lateLastWeek = computed(() => {
      if ('late' in props.reminders) {
        return props.reminders.late.lastWeek
      } else {
        return []
      }
    })
    const lateLastMonth = computed(() => {
      if ('late' in props.reminders) {
        return props.reminders.late.lastMonth
      } else {
        return []
      }
    })
    const lateForFarTooLong = computed(() => {
      if ('late' in props.reminders) {
        return props.reminders.late.forFarTooLong
      } else {
        return []
      }
    })
    const remindersWithoutCompletionDate = computed(() => {
      if ('withoutCompletionDate' in props.reminders) {
        return props.reminders.withoutCompletionDate.length
      } else {
        return 0
      }
    })

    const dateAvailables = computed(() => {
      // console.log(props.reminders)
      if (('byDates' in props.reminders)) {
        return Object.keys(props.reminders.byDates)
      } else {
        return []
      }
    })

    const displaySelectedDate = computed(() => {
      let now = moment().hour(0).minute(0).seconds(0)
      let tomorrow = moment(clone(now)).add(1, 'days')

      if (selectedDate.value != null) {
        if (now.format('YYYY-MM-DD') == moment(selectedDate.value).format('YYYY-MM-DD')) {
          return capitalize(i18n.t('today'))
        } else if (tomorrow.format('YYYY-MM-DD') == moment(selectedDate.value).format('YYYY-MM-DD')) {
          return capitalize(i18n.t('tomorrow'))
        } else {
          return capitalize(moment(selectedDate.value).format('LL'))
        }
      } else {
        return '-'
      }

    })

    const isPreviousDateAllowed = computed(() => {
      if (('byDates' in props.reminders)) {
        let index = Object.keys(props.reminders.byDates).findIndex(dateStr => dateStr == selectedDate.value)
        index--

        if (index < 0) {
          return false
        } else {
          return true
        }
      } else {
        return false
      }

    })

    const isNextDateAllowed = computed(() => {
      if (('byDates' in props.reminders)) {
        let index = Object.keys(props.reminders.byDates).findIndex(dateStr => dateStr == selectedDate.value)
        index++

        if (index >= Object.keys(props.reminders.byDates).length) {
          return false
        } else {
          return true
        }
      } else {
        return false
      }

    })

    const countLate = computed(() => {
      return lateYesterday.value.length +
          lateDayBeforeYesterday.value.length +
          lateLastWeek.value.length +
          lateLastMonth.value.length +
          lateForFarTooLong.value.length
    })

    const isWithoutCompletionDateCollapsed = ref(true)

    const componentKey = ref(0)

    // ------------------------------------------------
    // Watch
    // ------------------------------------------------
    // watch(reminderModalShow, val => {
    //   if (val == false) {
    //     resetReminder()
    //   }
    // })

    watch(dateAvailables, val => {
      if (val.length > 0) {
        selectedDate.value = val[0]
      }
    })

    // watch(currentReminder, val => {
    //   console.log(val)
    // }, { deep: true })

    // ------------------------------------------------
    // Methods
    // ------------------------------------------------
    // const { submitValidatedReminder, removeReminder } = useReminders()
    // const resetReminder = () => {
    //   currentReminder.value = clone(store.getters['reminder/getEmptyReminder'])
    //   reminderModalTitle.value = i18n.t('NewReminder')
    // }
    //
    // const addReminder = () => {
    //   reminderModalShow.value = true
    // }

    // const addExternalReminder = (reminder) => {
    //   currentReminder.value = clone(reminder)
    //
    //   reminderModalShow.value = true
    // }
    //
    // const editExternalReminder = (reminder) => {
    //   reminderModalTitle.value = capitalize(i18n.t('editReminder'))
    //
    //   store.dispatch('reminder/getReminder', reminder.id)
    //       .then(response => {
    //         currentReminder.value = response.data
    //
    //         if (response.data.isClosed == true) {
    //           removeReminderLocal(response.data.id)
    //         }
    //
    //         reminderModalShow.value = true
    //       })
    //
    // }
    //
    // const editReminder = (reminder) => {
    //   reminderModalTitle.value = capitalize(i18n.t('editReminder'))
    //
    //   store.dispatch('reminder/getReminder', reminder.id)
    //       .then(response => {
    //         currentReminder.value = response.data
    //
    //         if (response.data.isClosed == true) {
    //           removeReminderLocal(response.data.id)
    //         }
    //
    //         reminderModalShow.value = true
    //       })
    //
    // }
    //
    // const duplicateReminder = (reminderToDuplicate) => {
    //   store.dispatch('reminder/getReminder', reminderToDuplicate.id)
    //       .then(response => {
    //         currentReminder.value = clone(response.data)
    //         delete currentReminder.value.id
    //         delete currentReminder.value.logs
    //
    //         submitValidatedReminderLocal()
    //       })
    // }

    const checkReminderLocal = (reminder) => {
      // store.dispatch('reminder/getReminder', reminder.id)
      //     .then(response => {
      //       currentReminder.value = response.data
      //       currentReminder.value.isClosed = true
      //
      //       submitValidatedReminderLocal()

            // hideReminder(response.data.id)
            hideReminder(reminder.id)
            componentKey.value++
          // })
    }

    const hideReminder = id => {
      if ('late' in props.reminders) {
        props.reminders.late.yesterday = props.reminders.late.yesterday.filter(item => item.id != id)
        props.reminders.late.dayBeforeYesterday = props.reminders.late.dayBeforeYesterday.filter(item => item.id != id)
        props.reminders.late.lastWeek = props.reminders.late.lastWeek.filter(item => item.id != id)
        props.reminders.late.lastMonth = props.reminders.late.lastMonth.filter(item => item.id != id)
        props.reminders.late.forFarTooLong = props.reminders.late.forFarTooLong.filter(item => item.id != id)
      }

      if ('byDates' in props.reminders) {
        Object.keys(props.reminders.byDates).forEach(date => {
          props.reminders.byDates[date] = props.reminders.byDates[date].filter(item => item.id != id)
        })
      }
    }

    const removeReminderLocalLocal = (id) => {
      hideReminder(id)
    }

    // const submitValidatedReminderLocal = () => {
    //   submitValidatedReminder(currentReminder.value)
    //       .then(response => {
    //         // console.log(response)
    //
    //         reminderModalShow.value = false
    //         resetReminder()
    //
    //         emit('updateCalendar')
    //         emit('updateReminders')
    //       })
    // }

    const previousDate = () => {
      let index = Object.keys(props.reminders.byDates).findIndex(dateStr => dateStr == selectedDate.value)
      index--

      if (index >= 0) {
        selectedDate.value = dateAvailables.value[index]
      }
    }

    const nextDate = () => {
      let index = Object.keys(props.reminders.byDates).findIndex(dateStr => dateStr == selectedDate.value)
      index++

      if (index < dateAvailables.value.length) {
        selectedDate.value = Object.keys(props.reminders.byDates)[index]
      }

    }

    // ------------------------------------------------
    // Mounted
    // ------------------------------------------------

    // ------------------------------------------------
    // Setup
    // ------------------------------------------------
    // resetReminder()

    return {
      // Components
      capitalize,

      // Data
      // currentReminder,
      // reminderModalShow,
      // reminderModalTitle,
      selectedDate,
      isWithoutCompletionDateCollapsed,
      componentKey,

      // Computed
      lateYesterday,
      lateDayBeforeYesterday,
      lateLastWeek,
      lateLastMonth,
      lateForFarTooLong,
      remindersWithoutCompletionDate,
      dateAvailables,
      displaySelectedDate,
      isPreviousDateAllowed,
      isNextDateAllowed,
      countLate,

      // Methods
      // addReminder,
      // addExternalReminder,
      // editExternalReminder,
      // editReminder,
      // duplicateReminder,
      hideReminder,
      // submitValidatedReminderLocal,
      previousDate,
      nextDate,
      checkReminderLocal,
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  methods: {
    removeReminderAlert (reminder = null) {
      if (reminder != null) {
        this.currentReminder = reminder
      }

      this.$bvModal
          .msgBoxConfirm(this.$t('DeleteAlert', { msg: this.$t('theReminder') }), {
            okVariant: 'danger',
            okTitle: this.capitalize(this.$t('delete')),
            cancelVariant: 'outline-secondary',
            cancelTitle: this.capitalize(this.$t('cancel')),
            centered: true,
          })
          .then(value => {
            if (value == true) {
              this.removeReminderLocal()
              this.hideReminder(this.currentReminder)
            }
          })
    }
  },
  mounted () {
  },
  created () {
  }
}
</script>

<style
    scoped
    lang="scss"
>

</style>